import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import { noop } from 'ui-components/default-props/noop';
import Global from '../../../../../store/global-selectors';
import { SimpleDropdown } from '../../../../simple-dropdown';

const messages = defineMessages({
  defaultLabel: {
    description: 'shipmentEmailTemplateDropdownContainer.defaultLabel',
    defaultMessage: 'Shipment Email Template',
    id: 'sFYnlS',
  },
  defaultTitle: {
    description: 'shipmentEmailTemplateDropdownContainer.defaultTitle',
    defaultMessage: 'Select Template',
    id: 'zNzdSA',
  },
});

const ShipmentEmailTemplateDropdown = ({
  dropdownMenuShouldHaveWidthOfButton = false,
  onItemSelected = noop,
  required = false,
  selectedShipmentEmailTemplateId = '',
  hasError = false,
}) => {
  const label = <FormattedMessage {...messages.defaultLabel} />;
  const defaultTitle = <FormattedMessage {...messages.defaultTitle} />;

  const shipmentEmailTemplates = useSelector(Global.selectSellerShipmentTemplates);
  const items = shipmentEmailTemplates.map(({ name, emailTemplateId }) => ({
    name,
    key: emailTemplateId,
  }));

  return (
    <SimpleDropdown
      defaultTitle={defaultTitle}
      dropdownMenuShouldHaveWidthOfButton={dropdownMenuShouldHaveWidthOfButton}
      hasError={hasError}
      items={items}
      label={label}
      onItemSelected={onItemSelected}
      required={required}
      selectedItemKey={selectedShipmentEmailTemplateId}
    />
  );
};

ShipmentEmailTemplateDropdown.propTypes = {
  dropdownMenuShouldHaveWidthOfButton: PropTypes.bool,
  onItemSelected: PropTypes.func,
  required: PropTypes.bool,
  selectedShipmentEmailTemplateId: PropTypes.string,
  hasError: PropTypes.bool,
};

export default ShipmentEmailTemplateDropdown;
